import React from "react";
import Radio from "./index";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";
import isEmpty from "lodash/isEmpty";

const RadioEdit = (props) => {
  const { extra = {}, builder } = props;
  const { options = null, optionsType } = extra;

  if (builder && optionsType === "static" && isEmpty(options)) {
    return <UnconfiguredComponent hint="Add options to component" />;
  }

  if (optionsType === "effects" || optionsType === "register") {
    return (
      <Radio
        {...props}
        extra={{ ...props.extra }}
        effects={{
          ...props.effect,
          ...{
            [props.id]: [
              { label: "Dynamic Content #1", value: "dynamic1" },
              { label: "Dynamic Content #2", value: "dynamic1" },
              { label: "Dynamic Content #3", value: "dynamic1" },
            ],
          },
        }}
      />
    );
  }

  return <Radio {...props} />;
};

export default RadioEdit;
